import { useMutation } from "@tanstack/react-query";
import { UPLOAD_URL } from "../util/constants";
import useAxios from "./useAxios";

const useUploadCommunityLogo = (token: string) => {
  const axiosInstance = useAxios();

  return useMutation({
    mutationFn: (image: FormData) =>
      axiosInstance
        .post<string>(`${UPLOAD_URL}/community/upload/${token}`, image)
        .then((res) => res.data),
  });
};

export default useUploadCommunityLogo;
